import { Component } from '@angular/core';
@Component({
  selector: 'app-visit',
  templateUrl: './visit.component.html'
})
export class VisitComponent {

}
